import { useEffect } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import dayjs
 from "dayjs";
const MessageLists = ({
  alerts = [],
  infos = [],
  warnings = [],
  messages = [],
  consequences = [],
  recommendations = [],
}) => {
  const navigate = useNavigate();

  useEffect(() => {}, []);

  const handleMessageClick = (message) => {
    window.showAlert(message.subject, message.message);
  };

  return (
    <>
      {alerts.map((alert) => (
        <Alert severity="error" key={alert.title} sx={{mb:1}}>
          <AlertTitle>*** ALERT *** - {alert.title}</AlertTitle>
          {alert.description}
        </Alert>
      ))}

      {warnings.map((alert) => (
        <Alert severity="warning" key={alert.title} sx={{mb:1}}>
          <AlertTitle>{alert.title}</AlertTitle>
          {alert.description}
        </Alert>
      ))}

      {consequences.map((con) => (
        <Alert severity="warning" key={con.eid} sx={{mb:1}}>
          <AlertTitle>
            Consequence: {con.consequenceName} for {con.scoreCategoryName}
          </AlertTitle>
          {con.consequenceDescription}
        </Alert>
      ))}

      {infos.map((alert) => (
        <Alert severity="info" key={alert.title} sx={{mb:1}}>
          <AlertTitle>{alert.title}</AlertTitle>
          {alert.description}
        </Alert>
      ))}

      {messages.length < 2 &&
        messages.map((message) => (
          <Alert severity="info" key={message.id} sx={{mb:1}}>
            <AlertTitle>
              <Link
                onClick={() => {
                  handleMessageClick(message);
                }}
                component="button"
                sx={{color:"black"}}
              >
                {message.subject} (click for more)
              </Link>
            </AlertTitle>
          </Alert>
        ))}

      {messages.length >= 2 && (
        <Link
          onClick={() => {
            navigate("/student/messages");
          }}
        >
          View Messages Here
        </Link>
      )}

      {recommendations.length > 0 && (
        <>
          <Typography
            variant="h5"
            component="h2"
            sx={{ mt: 1, fontFamily: "arial", fontWeight: "700" }}
          >
            Recommendations:
          </Typography>

          <Alert severity="success" sx={{mb:1}}>
            <AlertTitle>
              {recommendations.map((rec) => (
                <>
                  {rec.teacherLastName}: {rec.activityName} for{" "}
                  {dayjs(rec.date).format("MMM. D (dddd)")}
                  <br />
                </>
              ))}
            </AlertTitle>
          </Alert>
        </>
      )}
    </>
  );
};

export default MessageLists;
